import React from "react";
import { Link } from "react-router-dom";

const Home = () => {
  return (
    <section className="section section-hero" aria-labelledby="hero-heading">
      <div className="container hero-grid">
        <div className="hero-text">
          <p className="eyebrow">Welcome to Wellness Minds</p>
          <h1 id="hero-heading" className="hero-title">
            Feel calmer, clearer and more supported in your everyday life.
          </h1>
          <p className="hero-subtitle">
            Wellness Minds is a gentle mental wellness space focused on simple, realistic
            support. We help people notice how they&apos;re feeling, understand what might
            be behind it and take small steps toward feeling better.
          </p>
          <div className="hero-actions">
            <Link to="/contact" className="btn btn-primary">
              Contact us
            </Link>
            <Link to="/about" className="btn btn-outline">
              Learn more about Wellness Minds
            </Link>
          </div>
          <p className="hero-note">
            No judgment. No pressure to be &quot;fine&quot;. Just space to start where you are.
          </p>
        </div>

        <aside className="hero-card" aria-label="Wellness Minds highlights">
          <h2 className="hero-card-title">What we focus on</h2>
          <ul className="hero-list">
            <li>Support for stress, overwhelm and emotional exhaustion.</li>
            <li>Simple mental wellness check-ins and reflections.</li>
            <li>Practical, everyday ideas to care for your mind.</li>
          </ul>
          <p className="hero-card-footer">
            Wellness Minds is designed to work alongside your life, not against it.
          </p>
        </aside>
      </div>
    </section>
  );
};

export default Home;
